import { S25Util } from "../../util/s25-util";
import { S25Datefilter } from "../s25-dateformat/s25.datefilter.service";
import { Proto } from "../../pojo/Proto";
import { FileStoreUtil } from "../../util/filestore.util";
import { Item } from "../../pojo/Item";
import { CustomAttributes } from "../../pojo/CustomAttributes";
import { UserType } from "./student.engagement.service";
import { S25Icons } from "../s25-icon/s25.icon.const";

export type ViewMode = {
    id: string;
    name: string;
    showByDefault?: boolean;
    iconProp?: S25Icons.Name;
    permIds?: UserType[];
    subModes?: ViewMode[];
};

export class StudentEngagementUtil {
    public static readonly ViewModes: ViewMode[] = [
        { id: "dash", name: "Dashboard", showByDefault: true, iconProp: "dashboard" },
        { id: "chat", name: "Chat", showByDefault: true, iconProp: "chat" },
        {
            id: "forms",
            name: "Forms",
            permIds: [UserType.ADMIN],
            iconProp: "text",
            subModes: [{ id: "myForms", name: "My Forms", permIds: [UserType.ADMIN, UserType.OFFICER] }],
        },
        {
            id: "budget",
            name: "Budget",
            permIds: [UserType.ADMIN, UserType.OFFICER],
            iconProp: "reports",
            subModes: [{ id: "budgetRules", name: "Budget Rules", permIds: [UserType.ADMIN] }],
        },
        {
            id: "workflow",
            name: "Workflow",
            permIds: [UserType.ADMIN],
            iconProp: "excel",
            subModes: [
                { id: "myWorkflow", name: "My Workflow", permIds: [UserType.ADMIN, UserType.OFFICER] },
                { id: "workflowRules", name: "Workflow Rules", permIds: [UserType.ADMIN] },
                { id: "workflowActionHistory", name: "Workflow Action History", permIds: [UserType.ADMIN] },
                { id: "workflowAdmin", name: "Workflow Admin", permIds: [UserType.ADMIN] },
            ],
        },
        { id: "groups", name: "Approval Groups", permIds: [UserType.ADMIN], iconProp: "queue" },
    ] as const;

    public static readonly LogoAttrIds: Partial<Record<Item.Ids, number>> = {
        [Item.Ids.Event]: CustomAttributes.system.HotEventImage.id,
        [Item.Ids.Organization]: CustomAttributes.system.StudentEngagementOrgLogo.id,
    } as const;

    public static formatDate(start: string, end: string, datePrefs: { date: string; dateTime: string; time: string }) {
        const { date, dateTime, time } = datePrefs;
        if (S25Util.date.equalDate(start, end)) {
            return `${S25Datefilter.transform(start, date)} ${S25Datefilter.transform(start, time)} - ${S25Datefilter.transform(end, time)}`;
        } else {
            return `${S25Datefilter.transform(start, dateTime)} - ${S25Datefilter.transform(end, dateTime)}`;
        }
    }

    public static parseUrl(url: Proto.URLString) {
        if (!url) return null;
        if (url.includes("://")) {
            return url;
        } else if (FileStoreUtil.isFileStoreUrl(url)) {
            return FileStoreUtil.getImageUrl(url);
        }
    }
}
